import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Verifica completa delle variabili d'ambiente
Object.entries(firebaseConfig).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`Configurazione Firebase: manca ${key}. Controlla il file .env`);
  }
});

let app;
let auth;
let db;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  
  // Verifica inizializzazione
  if (!app || !auth || !db) {
    throw new Error('Inizializzazione Firebase fallita');
  }

  // Configura la persistenza dell'autenticazione
  setPersistence(auth, browserLocalPersistence)
    .catch((error) => {
      throw new Error(`Errore di persistenza auth: ${error.code}`);
    });

  // Monitoraggio auth state
  auth.onAuthStateChanged(() => {});

} catch (error) {
  throw new Error(`Errore di inizializzazione Firebase: ${error.message}`);
}

// Implementazione rate limiting
const rateLimiter = {
  attempts: {},
  maxAttempts: 5,
  lockoutDuration: 15 * 60 * 1000, // 15 minuti
  
  isLocked(userId) {
    const userAttempts = this.attempts[userId];
    if (!userAttempts) return false;
    
    if (userAttempts.count >= this.maxAttempts && 
        Date.now() - userAttempts.timestamp < this.lockoutDuration) {
      return true;
    }
    
    // Reset se il lockout è scaduto
    if (Date.now() - userAttempts.timestamp >= this.lockoutDuration) {
      delete this.attempts[userId];
    }
    return false;
  },
  
  recordAttempt(userId) {
    if (!this.attempts[userId]) {
      this.attempts[userId] = { count: 0, timestamp: Date.now() };
    }
    this.attempts[userId].count++;
    this.attempts[userId].timestamp = Date.now();
  }
};

// Funzione di sicurezza per verificare l'autenticazione
const ensureAuthenticated = () => {
  if (!auth.currentUser) {
    throw new Error('Utente non autenticato');
  }
  return true;
};

// Funzione per sanitizzare input
const sanitizeInput = (input) => {
  if (typeof input === 'string') {
    return input.trim().replace(/[<>]/g, '');
  }
  return input;
};

export { auth, db, rateLimiter, ensureAuthenticated, sanitizeInput };
export default app;